import { Component, Input } from '@angular/core';
import { IOperationPolDetail } from '../../../../../processes/models/processes.models';
import { ItemCheckFacialRecognitionComponent } from '../item-check-facial-recognition/item-check-facial-recognition.component';
import { IOperationDetailResponse } from '../../../../../operations/models/operations.models';

@Component({
	selector: 'app-operation-pol-checks-compare-info',
	imports: [ItemCheckFacialRecognitionComponent],
	templateUrl: './operation-pol-checks-compare-info.component.html',
	styleUrl: './operation-pol-checks-compare-info.component.scss',
})
export class OperationPolChecksCompareInfoComponent {
	@Input() detail: IOperationDetailResponse;
}
